import { QUOTES_CODE_MAPPING } from '@fe-common-utils/libs/quote';
import { GETv4MarketFocus } from '@fe-news/api/quotes';
import queries from '@fe-news/components/ReactQuery';
import { useQuery } from '@tanstack/react-query';

export type MarketDataType = {
  date: number;
  displayName: string;
  price: number;
  change: number;
  ratio: number;
};

const sucessStatusCode = 200;
const emptyValue = '--';

const defaultValue = {
  date: emptyValue,
  displayName: emptyValue,
  price: emptyValue,
  change: 0,
  ratio: 0
};

export const fetchMarketFocus = async (type: string) => {
  // [ANUE-8916]市場焦點-API取用參數調整為格式化報價(最新價/漲跌幅改成用v2字串版本,顯示位數由後端調整)
  try {
    const response = await GETv4MarketFocus({
      type,
      column: 'F_Format_v2'
    });

    if (response.statusCode === sucessStatusCode) {
      return response?.data?.[type]?.items ?? [];
    }

    return [];
  } catch (error) {
    console.error(`[Aside MarketFocus Error]: ${error}`);
    return [];
  }
};

const formatData = (data: Quote[], limit: number) => {
  if (data.length === 0) return Array.from({ length: limit }).fill(defaultValue);

  return data.map(quote => {
    const date = (quote[QUOTES_CODE_MAPPING.TradeTime as QuoteKeys] as string) || emptyValue;
    const name = quote[QUOTES_CODE_MAPPING.ChineseName as QuoteKeys] || null;
    const shortName = quote[QUOTES_CODE_MAPPING.ShortName as QuoteKeys] || null;
    const displayName = shortName || name || emptyValue;
    const price = quote[QUOTES_CODE_MAPPING.lastFormat as QuoteKeys] || emptyValue;
    const change = quote[QUOTES_CODE_MAPPING.netChangeFormat as QuoteKeys] || 0;
    const ratio = quote[QUOTES_CODE_MAPPING.ChangePercentV2 as QuoteKeys] || 0;
    const symbol = quote[QUOTES_CODE_MAPPING.Symbol as QuoteKeys] || emptyValue;
    const code = quote[QUOTES_CODE_MAPPING.Symbol as QuoteKeys] || '';

    return { date, displayName, price, change, ratio, symbol, code };
  });
};

const useFetchMarketFocus = (type: string, limit: number) => {
  const { data, isFetching } = useQuery({
    ...queries.quotes.quoteByMarketFocus(type),
    select: queryData => formatData(queryData, limit),
    initialData: []
  });

  return { data: data ?? [], isLoading: isFetching };
};

export default useFetchMarketFocus;
